import React from "react"
import { useTranslation } from "react-i18next"
import MyStory from "../component/sections/MyStory"
import MissionAndVision from "../component/sections/MissionAndVision"
import ContactInfo from "../component/sections/ContactInfo"

const About = () => {
  const { t } = useTranslation()

  return (
    <>
      <section className="mx-auto max-w-7xl p-8 bg-blue-100">
        <h1 className="text-2xl md:text-4xl font-semibold mb-4">
          {t("about.title")}
        </h1>
        <p className="text-lg md:text-xl text-gray-600">
          {t("about.subtitle")}
        </p>
      </section>
      <MyStory />
      <MissionAndVision />
      <ContactInfo />
    </>
  )
}

export default About
